/**
 * Appointment section provider for Global Search (list API → SearchHit).
 */

import type { GlobalSearchSectionProvider } from '@/shared/search/types';
import { appointmentAPI } from '../api/appointment.api';
import {
  getAppointmentSubjectName,
  getAppointmentSubjectPhone,
} from '../utils/appointmentSubject';

export const appointmentSearchProvider: GlobalSearchSectionProvider = {
  id: 'appointments',
  permission: 'appointments:read',
  titleKey: 'globalSearchAppointments',
  iconId: 'appointments',
  rankByAcronym: true,
  search: async (query, { limit }) => {
    const res = await appointmentAPI.getAppointments({
      search: query,
      limit,
    });
    return (res.data ?? []).slice(0, limit).map((appt) => {
      const idValue = appt._id;
      const subject = getAppointmentSubjectName(appt, appt.appointmentCode || idValue);
      const phone = getAppointmentSubjectPhone(appt);
      const secondary = [appt.appointmentCode, phone, appt.status]
        .filter(Boolean)
        .join(' · ');
      return {
        id: idValue,
        sectionId: 'appointments',
        primary: subject,
        secondary: secondary || undefined,
        path: `/appointments/${idValue}`,
      };
    });
  },
};
